import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[AutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  @Input() AutoFocus: boolean = true;

  public constructor(private el: ElementRef) {}

  public ngAfterViewInit() {
    if (this.AutoFocus) {
      setTimeout(() => {
        this.el.nativeElement.focus();
      }, 100);
    }
  }
}